/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  APIUsageLog,
  ApiUsageLogListParams,
  PaginatedAPIUsageLogList,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * ViewSet for tracking API usage and costs.

Endpoints:
    GET /api/api-usage-logs/ - List all API calls with filtering
    GET /api/api-usage-logs/{id}/ - Get details of specific API call
    GET /api/api-usage-logs/stats/summary/ - Get cost summary
    GET /api/api-usage-logs/stats/by-service/ - Get costs by service
    GET /api/api-usage-logs/stats/by-date/ - Get costs by date
 * @summary API 사용량 로그 목록
 */
export const apiUsageLogList = (
  params?: ApiUsageLogListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedAPIUsageLogList>(
    { url: `/api/api-usage-logs/`, method: "GET", params, signal },
    options,
  );
};

export const getApiUsageLogListQueryKey = (params?: ApiUsageLogListParams) => {
  return [`/api/api-usage-logs/`, ...(params ? [params] : [])] as const;
};

export const getApiUsageLogListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiUsageLogList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiUsageLogListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiUsageLogListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiUsageLogList>>> = ({
    signal,
  }) => apiUsageLogList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiUsageLogList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ApiUsageLogListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiUsageLogList>>
>;
export type ApiUsageLogListQueryError = ErrorType<unknown>;

export function useApiUsageLogList<
  TData = Awaited<ReturnType<typeof apiUsageLogList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ApiUsageLogListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogList>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogList<
  TData = Awaited<ReturnType<typeof apiUsageLogList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiUsageLogListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogList>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogList<
  TData = Awaited<ReturnType<typeof apiUsageLogList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiUsageLogListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary API 사용량 로그 목록
 */

export function useApiUsageLogList<
  TData = Awaited<ReturnType<typeof apiUsageLogList>>,
  TError = ErrorType<unknown>,
>(
  params?: ApiUsageLogListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getApiUsageLogListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * ViewSet for tracking API usage and costs.

Endpoints:
    GET /api/api-usage-logs/ - List all API calls with filtering
    GET /api/api-usage-logs/{id}/ - Get details of specific API call
    GET /api/api-usage-logs/stats/summary/ - Get cost summary
    GET /api/api-usage-logs/stats/by-service/ - Get costs by service
    GET /api/api-usage-logs/stats/by-date/ - Get costs by date
 * @summary API 사용량 로그 상세
 */
export const apiUsageLogRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<APIUsageLog>(
    { url: `/api/api-usage-logs/${id}/`, method: "GET", signal },
    options,
  );
};

export const getApiUsageLogRetrieveQueryKey = (id?: string) => {
  return [`/api/api-usage-logs/${id}/`] as const;
};

export const getApiUsageLogRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiUsageLogRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiUsageLogRetrieve>>
  > = ({ signal }) => apiUsageLogRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ApiUsageLogRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiUsageLogRetrieve>>
>;
export type ApiUsageLogRetrieveQueryError = ErrorType<unknown>;

export function useApiUsageLogRetrieve<
  TData = Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogRetrieve<
  TData = Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogRetrieve<
  TData = Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary API 사용량 로그 상세
 */

export function useApiUsageLogRetrieve<
  TData = Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getApiUsageLogRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get costs grouped by date.

Query params:
    ?days=7 - Last 7 days (default: 30)

Returns:
{
    "results": [
        {
            "date": "2025-12-27",
            "total_cost": 1.25,
            "call_count": 125,
            "success_count": 120
        },
        ...
    ]
}
 * @summary 날짜별 API 사용량
 */
export const apiUsageLogByDate = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<APIUsageLog>(
    { url: `/api/api-usage-logs/by_date/`, method: "GET", signal },
    options,
  );
};

export const getApiUsageLogByDateQueryKey = () => {
  return [`/api/api-usage-logs/by_date/`] as const;
};

export const getApiUsageLogByDateQueryOptions = <
  TData = Awaited<ReturnType<typeof apiUsageLogByDate>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof apiUsageLogByDate>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiUsageLogByDateQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiUsageLogByDate>>
  > = ({ signal }) => apiUsageLogByDate(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiUsageLogByDate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ApiUsageLogByDateQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiUsageLogByDate>>
>;
export type ApiUsageLogByDateQueryError = ErrorType<unknown>;

export function useApiUsageLogByDate<
  TData = Awaited<ReturnType<typeof apiUsageLogByDate>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByDate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogByDate>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogByDate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogByDate<
  TData = Awaited<ReturnType<typeof apiUsageLogByDate>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByDate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogByDate>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogByDate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogByDate<
  TData = Awaited<ReturnType<typeof apiUsageLogByDate>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByDate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 날짜별 API 사용량
 */

export function useApiUsageLogByDate<
  TData = Awaited<ReturnType<typeof apiUsageLogByDate>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByDate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getApiUsageLogByDateQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get costs grouped by operation type.

Returns:
{
    "results": [
        {
            "operation": "generate_metadata",
            "service": "claude",
            "total_cost": 2.50,
            "call_count": 250,
            "success_count": 248,
            "average_cost": 0.01,
            "average_duration": 0.30
        },
        ...
    ]
}
 * @summary 작업별 API 사용량
 */
export const apiUsageLogByOperation = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<APIUsageLog>(
    { url: `/api/api-usage-logs/by_operation/`, method: "GET", signal },
    options,
  );
};

export const getApiUsageLogByOperationQueryKey = () => {
  return [`/api/api-usage-logs/by_operation/`] as const;
};

export const getApiUsageLogByOperationQueryOptions = <
  TData = Awaited<ReturnType<typeof apiUsageLogByOperation>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof apiUsageLogByOperation>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiUsageLogByOperationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiUsageLogByOperation>>
  > = ({ signal }) => apiUsageLogByOperation(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiUsageLogByOperation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ApiUsageLogByOperationQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiUsageLogByOperation>>
>;
export type ApiUsageLogByOperationQueryError = ErrorType<unknown>;

export function useApiUsageLogByOperation<
  TData = Awaited<ReturnType<typeof apiUsageLogByOperation>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByOperation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogByOperation>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogByOperation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogByOperation<
  TData = Awaited<ReturnType<typeof apiUsageLogByOperation>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByOperation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogByOperation>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogByOperation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogByOperation<
  TData = Awaited<ReturnType<typeof apiUsageLogByOperation>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByOperation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 작업별 API 사용량
 */

export function useApiUsageLogByOperation<
  TData = Awaited<ReturnType<typeof apiUsageLogByOperation>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByOperation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getApiUsageLogByOperationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get costs grouped by service.

Returns:
{
    "results": [
        {
            "service": "claude",
            "total_cost": 5.50,
            "call_count": 550,
            "success_count": 545,
            "failure_count": 5,
            "average_cost": 0.01,
            "average_duration": 0.45
        },
        ...
    ]
}
 * @summary 서비스별 API 사용량
 */
export const apiUsageLogByService = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<APIUsageLog>(
    { url: `/api/api-usage-logs/by_service/`, method: "GET", signal },
    options,
  );
};

export const getApiUsageLogByServiceQueryKey = () => {
  return [`/api/api-usage-logs/by_service/`] as const;
};

export const getApiUsageLogByServiceQueryOptions = <
  TData = Awaited<ReturnType<typeof apiUsageLogByService>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof apiUsageLogByService>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiUsageLogByServiceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiUsageLogByService>>
  > = ({ signal }) => apiUsageLogByService(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiUsageLogByService>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ApiUsageLogByServiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiUsageLogByService>>
>;
export type ApiUsageLogByServiceQueryError = ErrorType<unknown>;

export function useApiUsageLogByService<
  TData = Awaited<ReturnType<typeof apiUsageLogByService>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByService>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogByService>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogByService>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogByService<
  TData = Awaited<ReturnType<typeof apiUsageLogByService>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByService>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogByService>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogByService>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogByService<
  TData = Awaited<ReturnType<typeof apiUsageLogByService>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByService>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 서비스별 API 사용량
 */

export function useApiUsageLogByService<
  TData = Awaited<ReturnType<typeof apiUsageLogByService>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogByService>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getApiUsageLogByServiceQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get recent API calls (last 50).

Returns:
{
    "results": [
        {
            "id": "...",
            "service_name": "claude",
            "operation": "generate_metadata",
            "success": true,
            "estimated_cost": 0.01,
            "duration_seconds": 0.45,
            "created_at": "2025-12-27T14:30:00Z"
        },
        ...
    ]
}
 * @summary 최근 API 호출 목록
 */
export const apiUsageLogRecent = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<APIUsageLog>(
    { url: `/api/api-usage-logs/recent/`, method: "GET", signal },
    options,
  );
};

export const getApiUsageLogRecentQueryKey = () => {
  return [`/api/api-usage-logs/recent/`] as const;
};

export const getApiUsageLogRecentQueryOptions = <
  TData = Awaited<ReturnType<typeof apiUsageLogRecent>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof apiUsageLogRecent>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiUsageLogRecentQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiUsageLogRecent>>
  > = ({ signal }) => apiUsageLogRecent(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiUsageLogRecent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ApiUsageLogRecentQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiUsageLogRecent>>
>;
export type ApiUsageLogRecentQueryError = ErrorType<unknown>;

export function useApiUsageLogRecent<
  TData = Awaited<ReturnType<typeof apiUsageLogRecent>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogRecent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogRecent>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogRecent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogRecent<
  TData = Awaited<ReturnType<typeof apiUsageLogRecent>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogRecent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogRecent>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogRecent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogRecent<
  TData = Awaited<ReturnType<typeof apiUsageLogRecent>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogRecent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 최근 API 호출 목록
 */

export function useApiUsageLogRecent<
  TData = Awaited<ReturnType<typeof apiUsageLogRecent>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogRecent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getApiUsageLogRecentQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get cost summary for user.

Returns:
{
    "total_cost": 12.34,
    "total_calls": 45,
    "successful_calls": 43,
    "failed_calls": 2,
    "success_rate": 95.56,
    "average_cost_per_call": 0.29,
    "period": "all_time"
}
 * @summary API 사용량 요약
 */
export const apiUsageLogSummary = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<APIUsageLog>(
    { url: `/api/api-usage-logs/summary/`, method: "GET", signal },
    options,
  );
};

export const getApiUsageLogSummaryQueryKey = () => {
  return [`/api/api-usage-logs/summary/`] as const;
};

export const getApiUsageLogSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof apiUsageLogSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof apiUsageLogSummary>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiUsageLogSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiUsageLogSummary>>
  > = ({ signal }) => apiUsageLogSummary(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiUsageLogSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ApiUsageLogSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiUsageLogSummary>>
>;
export type ApiUsageLogSummaryQueryError = ErrorType<unknown>;

export function useApiUsageLogSummary<
  TData = Awaited<ReturnType<typeof apiUsageLogSummary>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogSummary>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogSummary<
  TData = Awaited<ReturnType<typeof apiUsageLogSummary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiUsageLogSummary>>,
          TError,
          Awaited<ReturnType<typeof apiUsageLogSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useApiUsageLogSummary<
  TData = Awaited<ReturnType<typeof apiUsageLogSummary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary API 사용량 요약
 */

export function useApiUsageLogSummary<
  TData = Awaited<ReturnType<typeof apiUsageLogSummary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof apiUsageLogSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getApiUsageLogSummaryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
